import React, { useState } from "react";
import { HiPlay } from "react-icons/hi";
import Dialog from "@mui/material/Dialog";
import YouTube from "react-youtube";
import { styled } from "@mui/styles";

const Banner = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const CustomDialog = styled(Dialog)(() => ({
    "& .MuiDialogContent-root": {},
    "& .MuiDialogActions-root": {},
    "& .MuiDialog-container": {
      "& .MuiDialog-paper": {
        backgroundColor: "transparent",
        maxWidth: "500px",
        width: "100%",
      },
    },
  }));

  return (
    <section className="py-28 md:py-40">
      <div className="container  ">
        <h1 className="text-center text-[30px] md:text-[48px] font-semibold  max-w-3xl mx-auto">
          The Best Defi 3.0 <span className="text-primary">Staking</span> as a
          service platform.
        </h1>
        <p className="text-center max-w-lg mx-auto mt-4 text-base md:text-lg text-gray font-semibold">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
          fringilla lectus rhoncus turpis rhoncus.
        </p>
        <div className=" grid  md:grid-flow-col justify-center mt-10 gap-4">
          <button className=" bg-primary py-3 px-6 md:py-4 md:px-8 text-dark font-semibold rounded-lg text-sm">
            ENTER APP
          </button>
          <button
            className=" bg-transparent border-2 border-dark-400 py-3 px-6 md:py-4 md:px-8 text-white  font-semibold rounded-lg text-sm
            grid grid-flow-col items-center gap-2

          "
            onClick={() => setShow(true)}
          >
            <span className="text-xl">
              <HiPlay />
            </span>{" "}
            <span> WATCH VIDEO</span>
          </button>
        </div>
      </div>
      <CustomDialog onClose={handleClose} open={show} className="">
        <div className=" w-full overflow-hidden">
          <YouTube
            videoId="t0Q2otsqC4I"
            opts={{
              width: "100%",
              height: "500px",
            }}
          />
        </div>
      </CustomDialog>
    </section>
  );
};

export default Banner;
